/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useContext, useState } from 'react';

export const SpeakerPanelContext = createContext({
  isSpeakerPanelOpen: false,
  setIsSpeakerPanelOpen: (_isSpeakerViewOpen: boolean) => {},
  isSpeakerPanelWarningVisible: true,
  setIsSpeakerPanelWarningVisible: (_val: boolean) => {},
});

export const useSpeakerPanelContext = () => {
  return useContext(SpeakerPanelContext);
};

export const SpeakerPanelContextProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const [isSpeakerPanelOpen, setIsSpeakerPanelOpen] = useState(false);
  const [isSpeakerPanelWarningVisible, setIsSpeakerPanelWarningVisible] =
    useState(false);

  return (
    <SpeakerPanelContext.Provider
      value={{
        isSpeakerPanelOpen,
        setIsSpeakerPanelOpen,
        isSpeakerPanelWarningVisible,
        setIsSpeakerPanelWarningVisible,
      }}
    >
      {children}
    </SpeakerPanelContext.Provider>
  );
};
